// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pkr5cr{margin-top:var(--ds-space-negative-050,-4px)}\n._otyr1b66{margin-bottom:var(--ds-space-050,4px)}", ""]);
// Exports
module.exports = exports;
